import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export function ShareForm({ teamId, file, onDone }) {
  const [password, setPassword] = useState("");
  const [hours, setHours] = useState(24);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    const fd = new FormData();
    if (password) fd.append("password", password);
    fd.append("expires_in_hours", String(hours));
    try {
      const { data } = await api.post(`/teams/${teamId}/files/${file.id}/share`, fd);
      setResult(data);
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };

  if (result) return <ShareResult result={result} onDone={onDone}/>;
  return (
    <form onSubmit={submit} className="space-y-4">
      <div>
        <div className="text-xs text-black/55 mb-2 uppercase tracking-widest">Expires in</div>
        <select value={hours} onChange={(e) => setHours(Number(e.target.value))} data-testid="share-hours" className="w-full px-3 py-2.5 border border-black/15 rounded-md bg-white">
          <option value={1}>1 hour</option>
          <option value={6}>6 hours</option>
          <option value={24}>24 hours</option>
          <option value={72}>3 days</option>
          <option value={168}>7 days</option>
        </select>
      </div>
      <div>
        <div className="text-xs text-black/55 mb-2 uppercase tracking-widest">Password (optional)</div>
        <input data-testid="share-password" type="text" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-3 py-2.5 border border-black/15 rounded-md outline-none focus:border-black" placeholder="Leave blank for none"/>
      </div>
      <button data-testid="share-submit" disabled={busy} className="w-full bg-black text-white py-2.5 rounded-md disabled:opacity-50">{busy ? "Generating…" : "Generate share code"}</button>
    </form>
  );
}

function ShareResult({ result, onDone }) {
  const url = `${window.location.origin}/r/${result.code}`;
  const copy = () => { navigator.clipboard.writeText(url); toast.success("Link copied"); };
  return (
    <div className="space-y-3" data-testid="share-result">
      <div className="text-xs text-black/55 uppercase tracking-widest">Share code</div>
      <div className="bg-black text-[#FF3366] p-4 text-center font-mono text-3xl tracking-[0.2em] rounded-md">{result.code}</div>
      <button onClick={copy} className="w-full py-2.5 border border-black/15 rounded-md hover:bg-black/5" data-testid="copy-share-link">Copy link</button>
      <button onClick={onDone} className="w-full bg-black text-white py-2.5 rounded-md">Done</button>
    </div>
  );
}
